declare namespace $ {

	type $shm_hitalama_hovered__hovered_shm_hitalama_map_widget_float_notebook2_adds_line_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_notebook2_adds_line_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_notebook2_adds_line_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_map_page_contextmenu__item_ids_top_shm_hitalama_map_widget_float_notebook2_adds_line_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['item_ids_top'] >
	>
	type $shm_hitalama_map_page_contextmenu__item_ids_top2_shm_hitalama_map_widget_float_notebook2_adds_line_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['item_ids_top2'] >
	>
	type $shm_hitalama_map_page_contextmenu__item_ids_shm_hitalama_map_widget_float_notebook2_adds_line_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['add_types'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['item_ids'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_widget_float_notebook2_adds_line_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__contextmenu_real_pos_shm_hitalama_map_widget_float_notebook2_adds_line_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['real_pos'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_real_pos'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_notebook2_adds_line_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_notebook2_adds_line_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['button_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_notebook2_adds_line_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_widget_float_notebook2_adds_line_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_widget_float_notebook2_adds_line_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['Anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_widget_float_notebook2_adds_line_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	export class $shm_hitalama_map_widget_float_notebook2_adds_line extends $mol_view {
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		body( ): readonly(any)[]
		showed( ): boolean
		button_click( next?: any ): any
		Icon( ): $mol_icon_plus
		Anchor( ): $mol_button_minor
		Menu( ): $shm_hitalama_map_page_contextmenu
		plugins( ): readonly(any)[]
		Map_page( ): $shm_hitalama_map_page
		add_types( ): readonly(any)[]
		left_px( ): string
		top_px( ): string
		real_pos( ): readonly(any)[]
		widget_add( id: any, next?: any ): any
		sub( ): ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['body'] >
		attr( ): ({ 
			'shm_hitalama_map_widget_float_notebook2_add_line_showed': ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['showed'] >,
		})  & ReturnType< $mol_view['attr'] >
		style( ): ({ 
			'left': ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['left_px'] >,
			'top': ReturnType< $shm_hitalama_map_widget_float_notebook2_adds_line['top_px'] >,
		})  & ReturnType< $mol_view['style'] >
		Button( ): $mol_button_minor
		Pop_over( ): $mol_pop_over
	}
	
}

//# sourceMappingURL=line.view.tree.d.ts.map